'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import { SUBSCRIPTION, type Subscription } from '@/common/enums';
import { H2 } from '@/frontend/design-system/_marketing/typography/Heading/H2';
import { P3 } from '@/frontend/design-system/_marketing/typography/Paragraph/P3';
import { VerticalSpacer } from '@/frontend/design-system/layouts/VerticalSpacer';
import { SubscriptionTabs } from './_components/SubscriptionTabs';
import { AdvancedMentoring } from './Mentoring/AdvancedMentoring';
import { BasicMentoring } from './Mentoring/BasicMentoring';
export function MentoringPricing() {
  const $ = _c(18);
  const isMobile = useMediaQuery("(max-width: 1023px)");
  const [activeSubscriptionTab, setActiveSubscriptionTab] = useState(SUBSCRIPTION.PER_4_WEEKS);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <H2>Wybierz mentoring idealny dla Ciebie</H2>;
    t1 = <VerticalSpacer size="content" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activeSubscriptionTab || $[3] !== isMobile) {
    t2 = !isMobile && <div className="flex flex-col items-center"><P3 className="text-slate-900">Typ subskrypcji</P3><div className="h-3 w-full" /><SubscriptionTabs tabs={Object.values(SUBSCRIPTION) as Subscription[]} activeTab={activeSubscriptionTab} setActiveTab={setActiveSubscriptionTab} /></div>;
    $[2] = activeSubscriptionTab;
    $[3] = isMobile;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <section className="flex flex-col text-center">{t0}{t1}{t2}</section>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <VerticalSpacer size="content" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== activeSubscriptionTab) {
    t5 = <div className="flex-1"><BasicMentoring activeSubscriptionTab={activeSubscriptionTab} setActiveSubscriptionTab={setActiveSubscriptionTab} /></div>;
    $[8] = activeSubscriptionTab;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== activeSubscriptionTab) {
    t6 = <div className="flex-1"><AdvancedMentoring activeSubscriptionTab={activeSubscriptionTab} setActiveSubscriptionTab={setActiveSubscriptionTab} /></div>;
    $[10] = activeSubscriptionTab;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <div className="flex flex-col justify-between gap-6 lg:flex-row lg:gap-8">{t5}{t6}</div>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t7) {
    t8 = <section id="wybierz-mentoring-idealny-dla-ciebie">{t3}{t4}{t7}</section>;
    $[15] = t3;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}